import { render, staticRenderFns } from "./order-reciept-product-table.vue?vue&type=template&id=2deb2956&"
import script from "./order-reciept-product-table.vue?vue&type=script&lang=js&"
export * from "./order-reciept-product-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports